import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { MasterDataService } from '../../Services/MasterDataService';
import { BaseComponent } from '../../Library/BaseComponent';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ShiftSetUpModel } from '../../Models/RequestModels';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { PropertyBasicInfo } from '../../Models/GlobalEntities';

@Component({
  selector: 'Department',
  templateUrl: './Department.html',
})

export class Department extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    ModalRef: NgbModalRef;
    ModelRadio: string;
    //DeptId: number;
    //Model: ShiftSetUpModel;
    Model: ShiftSetUpModel;
    DeptList: any;
    PropertyList: Array<PropertyBasicInfo>;

    @Output() DepartmentChange: EventEmitter<ShiftSetUpModel> = new EventEmitter<ShiftSetUpModel>();

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);
    }
    ngOnInit(): void {
    //this.RequestModel.PropertyID = this.masterService.LoggedInUserData.PropertyId;
    }

    Open(RequestModel: ShiftSetUpModel): void {
        setTimeout(() => {
            this.Model = _.cloneDeep(RequestModel);
            this.Model.DeptId = 0;
            this.PropertyList = this.GetProperties_Action(this._AuthActionCodes.ShiftSetupview);
            this.GetDepartmentList();
            let ngbModalOptions: NgbModalOptions = {
                backdrop : 'static',
                centered: true
            };
            this.ModalRef = this.modalService.open(this.content, ngbModalOptions)
            this.ModalRef.result.then((result) => {
                // this.router.navigate(['Calls/JobConsole']);
            }, (reason) => { this.router.navigate(['Calls/JobConsole']); });
        })
        
    }
    ChangeDept(): void {
        if (this.Validated()) {
            this.ModalRef.close();
            this.DepartmentChange.emit(this.Model);
        }

    }

    Validated() {
        this.ClearErrors();
        if (this.Model.DeptId == 0) {
            this.AddError('ERR.ERR_SELECT_DEPARTMENT');
            return false;
        }
        return true;
    }

    GetDepartmentList(): void {
        let Dept = this.masterService.GetPropertyCache(this.Model.PropertyId).Dept;
        this.DeptList = Dept.filter(obj => this.CheckAuth_Dept_Action(this.Model.PropertyId, obj.Id, this._AuthActionCodes.ShiftSetupview) == true)
        this.DeptList = this.DeptList.filter(obj => obj.IsServiceDepartment === true);
    }

    
}
